/* Awtomic — customer portal custom JS (CX-5079).
   El snippet `awtomic-theme-custom.liquid` lo carga con <script async> desde siempre y el asset
   no existia: daba 404 en todas las paginas del storefront. Queda como no-op a proposito: hoy el
   styling del portal se resuelve entero en `awtomic-theme-custom.css`.
   Si alguna vez hace falta JS custom para khloud, va aca dentro del IIFE. */
(function () {
  'use strict';
})();
